import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";

import { Dialog, IconButton } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import ZoomInIcon from "@material-ui/icons/ZoomIn";
import ZoomOutIcon from "@material-ui/icons/ZoomOut";
import RestoreIcon from "@material-ui/icons/Restore";

const useStyles = makeStyles(theme => ({
	messageMedia: {
		objectFit: "cover",
		width: 250,
		height: 200,
        maxWidth: "100%",
        cursor: "zoom-in",
		borderTopLeftRadius: 8,
		borderTopRightRadius: 8,
		borderBottomLeftRadius: 8,
		borderBottomRightRadius: 8,
	},
}));

const ModalImageCors = ({ imageUrl, message }) => {
	const classes = useStyles();
    const [open, setOpen] = useState(false);
    const [zoom, setZoom] = useState(1);
    const changeZoom = (amount) => setZoom(value => Math.max(1, Math.min(5, value + amount)));
    const openImage = () => { setZoom(1); setOpen(true); };

	// ✅ FUNCIÓN PARA RENDERIZAR REACCIONES SOBRE LA IMAGEN
	const renderImageReactions = () => {
		if (!message?.reactions || message.reactions.length === 0) {
			return null;
		}

		// ✅ MOSTRAR SOLO LA ÚLTIMA REACCIÓN (COMO WHATSAPP WEB)
		const lastReaction = message.reactions[message.reactions.length - 1];

		return (
			<div style={{
				position: 'absolute',
				bottom: '8px',
				right: '8px',
				display: 'flex',
				alignItems: 'center',
				backgroundColor: 'rgba(255, 255, 255, 0.95)',
				borderRadius: '16px',
				padding: '4px 8px',
				boxShadow: '0 2px 4px rgba(0, 0, 0, 0.15)',
				zIndex: 5,
                pointerEvents: 'none',
				fontSize: '16px',
				minWidth: '32px',
				justifyContent: 'center'
			}}>
				<span>{lastReaction.type}</span>
			</div>
		);
	};

	// ✅ CORRECCIÓN CRÍTICA: Normalizar imageUrl de forma síncrona y directa
	// El backend envía: /public/flowbuilder-media/company-6/archivo.jpg
	// Debemos construir: http://localhost:8080/public/flowbuilder-media/company-6/archivo.jpg
	// SIN duplicar /public/
	const getImageUrl = () => {
		if (!imageUrl) return "";
		
		const origin = window.location.origin.replace(/\/$/, "");
		let normalizedUrl = imageUrl.trim();
		
		// ✅ Si ya es URL absoluta (http/https/blob), normalizar doble /public/
		if (normalizedUrl.startsWith("http://") || normalizedUrl.startsWith("https://") || normalizedUrl.startsWith("blob:")) {
			// ✅ CORRECCIÓN CRÍTICA: Eliminar TODAS las ocurrencias de doble /public/
			normalizedUrl = normalizedUrl.replace(/\/public\/\/public\//g, '/public/');
			normalizedUrl = normalizedUrl.replace(/\/public\/public\//g, '/public/');
			return normalizedUrl;
		}
		
		// ✅ Si empieza con /public/, construir URL completa
		if (normalizedUrl.startsWith("/public/")) {
			// ✅ CORRECCIÓN CRÍTICA: Eliminar doble /public/ ANTES de construir URL completa
			normalizedUrl = normalizedUrl.replace(/^\/public\/\/public\//, '/public/');
			normalizedUrl = normalizedUrl.replace(/^\/public\/public\//, '/public/');
			return `${origin}${normalizedUrl}`;
		}
		
		// ✅ Fallback: Si NO empieza con /public/, normalizar y construir URL
		let normalizedPath = normalizedUrl.replace(/^\/+/, "");
		normalizedPath = normalizedPath.replace(/^public\//, "");
		return `${origin}/public/${normalizedPath}`;
	};

	const finalImageUrl = getImageUrl();

	return (
		<div style={{ position: 'relative', display: 'inline-block' }}>
            <button type="button" onClick={openImage} aria-label="Ampliar imagen"
                style={{ border: 0, padding: 0, background: "transparent", display: "block", maxWidth: "100%", cursor: "zoom-in" }}>
                <img className={classes.messageMedia} src={finalImageUrl} alt="Imagen de la conversación" />
            </button>
            <Dialog fullScreen open={open} onClose={() => setOpen(false)} PaperProps={{ style: { backgroundColor: "rgba(0,0,0,0.95)", color: "white" } }}>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, padding: 8, gap: 8 }}>
                    <IconButton color="inherit" aria-label="Reducir imagen" disabled={zoom <= 1} onClick={() => changeZoom(-0.5)}><ZoomOutIcon /></IconButton>
                    <span aria-live="polite">{Math.round(zoom * 100)}%</span>
                    <IconButton color="inherit" aria-label="Ampliar imagen" disabled={zoom >= 5} onClick={() => changeZoom(0.5)}><ZoomInIcon /></IconButton>
                    <IconButton color="inherit" aria-label="Restablecer zoom" onClick={() => setZoom(1)}><RestoreIcon /></IconButton>
                    <IconButton color="inherit" aria-label="Cerrar imagen" onClick={() => setOpen(false)}><CloseIcon /></IconButton>
                </div>
                <div style={{ flex: 1, minHeight: 0, overflow: "auto", touchAction: "pan-x pan-y pinch-zoom" }}>
                    <div style={{ width: `${zoom * 100}%`, height: `${zoom * 100}%`, display: "flex", alignItems: "center", justifyContent: "center" }}>
                        <img src={finalImageUrl} alt="Imagen ampliada de la conversación" style={{ width: "100%", height: "100%", objectFit: "contain" }} />
                    </div>
                </div>
            </Dialog>
			{/* ✅ MOSTRAR REACCIONES SOBRE LA IMAGEN */}
			{renderImageReactions()}
		</div>
	);
};

export default ModalImageCors;
